<script>
    export let scale = 1;
    export let prevAreaHeight;
    export let distY = 0;

	let expanding = false;
	let start = null;
    let initial = null;
    $: height = scale * prevAreaHeight;
    $: transitionStyle = expanding ? 'bottom 0.3s' : 'height 0.3s, bottom 0.3s';

	function startExpand(event) {
		expanding = true
        if (event.type === 'touchstart') {
            start = event.touches[0].pageY;
        } else {
            start = event.pageY;
        }
		initial = height
	}

	function stopExpand() {
		expanding = false
		start = null
		initial = null
	}

	function expand(event) {
		if (!expanding) return;

        let delta;
        if (event.type === 'touchmove') {
            delta = start-event.touches[0].pageY;
        } else {
            delta = start-event.pageY
        }

        height = initial + delta
        scale = height / prevAreaHeight;
    }

    let moving = false;
    let initialLeft = null;
    let startLeft = 40;
    let left = 40;

    function startMove(event) {
        moving = true;
        if (event.type === 'touchstart') {
            startLeft = event.touches[0].pageX;
        } else {
            startLeft = event.pageX;
        }
        initialLeft = left
    }

    function stopMove() {
        moving = false;
        startLeft = null;
        initialLeft = null;
    }

    function move(event) {
        if (!moving) return;

        let deltaLeft;
        if (event.type === 'touchmove') {
            deltaLeft = startLeft-event.touches[0].pageX;
        } else {
            deltaLeft = startLeft-event.pageX
        }

        left = initialLeft - deltaLeft
    }
</script>

<svelte:window on:mouseup={() => {stopExpand(); stopMove()}} on:touchend={() => {stopExpand(); stopMove()}}
               on:mousemove={(e) => {expand(e); move(e)}} on:touchmove={(e) => {expand(e); move(e)}}/>

<div id="GPBackgroundScaler" style="height: {height}px; bottom:{distY * prevAreaHeight}px; left:{left}px; transition: {transitionStyle}">

<svg style="height: 100%" viewBox="0 0 52 120" fill="none" xmlns="http://www.w3.org/2000/svg">

<path  on:mousedown={startMove} on:touchstart={startMove} class="move" d="M25.6868 23.2157C32.1018 23.2157 37.2775 18.0079 37.2775 11.6077C37.2775 5.18317 32.0775 -0.00026601 25.6868 -0.00026601C19.2718 -0.0246014 14.0718 5.18317 14.0718 11.5834C14.0718 18.0079 19.2718 23.2157 25.6868 23.2157ZM37 25.5762C35.8579 25.5275 17.984 25.5275 16.1127 25.5762C14.0473 25.6249 12.0305 26.428 11.1314 28.3991L0.451976 67.6886C-0.689837 70.1951 0.40362 73.1397 2.90642 74.2591C5.43328 75.4029 8.37371 74.2591 9.49147 71.8013L12.1401 64.0383C12.1401 66.0338 11.6176 73.8333 11.6176 113.135C11.6176 116.42 14.2905 119.097 17.5709 119.097C20.8513 119.097 23.5242 116.42 23.5242 113.135V77.6052H27.8737V113.135C27.8737 116.42 30.5466 119.097 33.827 119.097C37.1074 119.097 39.7803 116.42 39.7803 113.135M39.7803 113.135V64.0383L42.4867 72.0446C43.6044 74.5025 46.5446 75.6462 49.0717 74.5025C51.5745 73.3831 52.668 70.4385 51.5262 67.9319L40.8467 28.6425C39.9477 26.6713 39.0654 25.6249 37 25.5762" fill="white" stroke="#606060" stroke-width="0.5"/>
<path d="M41 0H52V11L41 0Z" fill="black" fill-opacity="0.17"  on:mousedown={startExpand} on:touchstart={startExpand} class="resize"/>
<circle cx="44.5" cy="1.5" r="0.5" fill="white"/>
<circle cx="50.5" cy="1.5" r="0.5" fill="white"/>
<circle cx="48.5" cy="1.5" r="0.5" fill="white"/>
<circle cx="46.5" cy="1.5" r="0.5" fill="white"/>
<circle cx="50.5" cy="5.5" r="0.5" fill="white"/>
<circle cx="48.5" cy="5.5" r="0.5" fill="white"/>
<circle cx="50.5" cy="7.5" r="0.5" fill="white"/>
<circle cx="50.5" cy="3.5" r="0.5" fill="white"/>
<circle cx="48.5" cy="3.5" r="0.5" fill="white"/>
<circle cx="46.5" cy="3.5" r="0.5" fill="white"/>
</svg>

</div>

<style>
	.resize {
		cursor: nesw-resize;
	}
    .move {
        cursor: ew-resize;
    }
</style>